import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PotionAttemptDisplay, type PotionAttempt } from './PotionAttemptDisplay';

interface GameLoseScenarioProps {
  potionAttempts: PotionAttempt[];
  onHome: () => void;
  className?: string;
}

export const GameLoseScenario: React.FC<GameLoseScenarioProps> = ({ 
  potionAttempts, 
  onHome, 
  className = '' 
}) => {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    onHome();
    navigate('/');
  };

  return (
    <div className={`flex flex-col items-center min-h-screen bg-transparent text-white ${className}`}>
      {/* Gloomy Background Effects */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Floating disappointed particles */}
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className="absolute animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 2}s`,
              animationDuration: `${3 + Math.random() * 2}s`
            }}
          >
            💀
          </div>
        ))}
        
        {/* Removed dark overlay for cleaner look */}
        <div className="hidden" />
      </div>

      {/* Defeat Header - positioned at 15vh */}
      <div className="absolute top-0 left-0 right-0 z-10 flex flex-col items-center text-center space-y-4" style={{ marginTop: '15vh' }}>
        <div className="text-6xl animate-bounce">😵</div>
        <h1 className="text-5xl font-bold text-red-400 drop-shadow-lg">
          ALCHEMY FAILED!
        </h1>
        <p className="text-xl text-gray-300 font-medium">
          The Love Potion remains a mystery...
        </p>
      </div>

      {/* Main Content - positioned at 60vh */}
      <div className="absolute left-0 right-0 z-10 bg-gray-800 flex flex-col items-center space-y-8 p-8" style={{ marginTop: '60vh' }}>
        {/* Potion Attempts Display */}
        <div className="space-y-6">
          <div className="flex justify-center items-center space-x-16">
            {potionAttempts.map((attempt) => (
              <div key={attempt.attemptNumber} className="flex flex-col items-center">
                <PotionAttemptDisplay 
                  attempt={attempt} 
                  displayMode="lose"
                  className="transform hover:scale-105 transition-transform duration-300"
                />
                
                {/* Progress Indicator */}
                <div className="mt-2 text-white/60 text-sm">
                  {attempt.result.shape === 'Heart' ? '❤️ Shape!' :
                   attempt.result.color === 'Pink' ? '🌸 Color!' :
                   attempt.result.nameStyle === 'Romantic/Magical' ? '✨ Style!' :
                   '⚗️ Attempt'}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex space-x-6">
          <button
            onClick={handleHomeClick}
            className="px-8 py-4 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500 text-white font-bold text-lg rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
          >
            🏠  ホーム
          </button>
        </div>
      </div>
    </div>
  );
};